export default {
      id: "load-more-usage",
      viewBox: "0 0 800 800",
      url: __webpack_public_path__ + "img/icons.f163a2c6.svg#load-more",
      toString: function () {
        return this.url;
      }
    }